import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { UserData, LinkData } from '../../Models/Authentication/UserModel';
import { AnalyticsServiceService } from '../../Services/analytics-service.service';
import { BaseApiService } from '../../Services/base-api.service';
import { takeUntil, finalize } from 'rxjs';
import { BaseComponent } from '../../Base/base/base.component';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  encapsulation: ViewEncapsulation.None,standalone:false
})
export class ProfileComponent extends BaseComponent implements OnInit {

  user!: UserData
  form!: FormGroup;
  Links!: FormGroup;
  imageUrl: string = '../../../assets/images/Linktree/templates/DumyUser.png';
  loading: boolean = false;
  userRole: string = '';
  linksData: LinkData[] = []
  socialLink:LinkData[]=[]
  showUpdate: boolean = false
  username: string = ''
  deviceLocationData: any;
  deviceInformation: any;
  profileLink: string = 'https://touchconnectapp.web.app/'
  name:string='';
  email:string=''
  Qr:string='https://touchconnectapp.web.app/'
  constructor
    (

      private messageService: MessageService,
      private api: BaseApiService,
      private route: ActivatedRoute,
      private analytic: AnalyticsServiceService

    ) {

     super()
  }



  generateVCard(phone: string): string {
    return `
  BEGIN:VCARD
  VERSION:3.0
  FN:${this.name}
  TEL;TYPE=CELL:${phone}
  EMAIL:${this.email}
  END:VCARD
    `;
  }

  downloadVCard(phone: string) {
    const vCardContent = this.generateVCard(phone);
    const blob = new Blob([vCardContent], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${this.name}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }





  // getDeviceLocation() {
  //   this.analytic.getDeviceLocation().subscribe(
  //     (data) => {
  //       this.deviceLocationData = data;
  //     },
  //     (error) => {
  //     }
  //   );
  // }

  // getDeviceInformation() {
  //   this.deviceInformation = this.analytic.getDeviceInformation();
  // }


  GetAll(uid: any) {
    this.loading = true;
    this.api.read(`Auth/getByLink?username=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
      (
        {
          next:(response) => {
            this.user = response;
            if (this.user != null) {
              this.name  = this.user.userName,
              this.email = this.user.email;
              this.GetSocilaLinks(this.user.id);
              this.GetAllLinks(this.user.id);
            }
            this.loading = false;
          },
          error:(
            error
          ) => {
  
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }
      )
  }

  GetAllLinks(uid: any) {
    this.loading = true;
    this.api.read(`SocialLinks/UserLinks?userid=${uid}`).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe
      (
        {
          next:(response) => {
            this.linksData = response;
            this.loading   = false;
          },
          error:(
            error
          ) => {
  
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }
      )
  }

  getIconClass(link: string): string {
    if (this.isPhoneNumber(link)) {
      return 'fa fa-phone'; // Phone icon
  } else if (this.isEmailAddress(link)) {
      return 'fa fa-envelope'; // Email icon
  }
  else {
    const domain = this.extractDomain(link);
    switch (domain) {
      case 'youtube.com':
      case 'www.youtube.com':
        return 'fab fa-youtube'; // YouTube icon
      case 'facebook.com':
      case 'www.facebook.com':
        return 'fab fa-facebook'; // Facebook icon
      case 'twitter.com':
      case 'www.twitter.com':
        return 'fab fa-twitter'; // Twitter icon
      case 'instagram.com':
      case 'www.instagram.com':
        return 'fab fa-instagram'; // Instagram icon
      case 'linkedin.com':
      case 'www.linkedin.com':
        return 'fab fa-linkedin'; // LinkedIn icon
      case 'snapchat.com':
      case 'www.snapchat.com':
        return 'fab fa-snapchat'; // Snapchat icon
      case 'pinterest.com':
      case 'www.pinterest.com':
        return 'fab fa-pinterest'; // Pinterest icon
      case 'tiktok.com':
      case 'www.tiktok.com':
        return 'fab fa-tiktok'; // TikTok icon
      case 'reddit.com':
      case 'www.reddit.com':
        return 'fab fa-reddit'; // Reddit icon
      case 'whatsapp.com':
      case 'www.whatsapp.com':
        return 'fab fa-whatsapp'; // WhatsApp icon
      case 'wechat.com':
      case 'www.wechat.com':
        return 'fab fa-weixin'; // WeChat icon
      case 'tumblr.com':
      case 'www.tumblr.com':
        return 'fab fa-tumblr'; // Tumblr icon
      case 'discord.com':
      case 'www.discord.com':
        return 'fab fa-discord'; // Discord icon
      case 'telegram.org':
      case 'www.telegram.org':
        return 'fab fa-telegram'; // Telegram icon
      case 'weibo.com':
      case 'www.weibo.com':
        return 'fab fa-weibo';
      case 'vk.com':
      case 'www.vk.com':
        return 'fab fa-vk';
      case 'line.me':
      case 'www.line.me':
        return 'fab fa-line';
      case 'qq.com':
      case 'www.qq.com':
        return 'fab fa-qq';
      case 'xing.com':
      case 'www.xing.com':
        return 'fab fa-xing';
      case 'github.com':
      case 'www.github.com':
        return 'fab fa-github';
      case 'google.com':
      case 'www.google.com':
        return 'fab fa-google';
        case 'tel':
        return 'fa fa-phone'; // Phone icon
      case 'mailto':
        return 'fa fa-envelope'; // Email icon
      default:
        return 'fa fa-link';
    }
  }
  }
  private extractDomain(link: string): string {
    let domain;
    // Find & remove protocol (http, ftp, etc.) and get domain
    if (link.indexOf('://') > -1) {
      domain = link.split('/')[2];
    } else {
      domain = link.split('/')[0];
    }
    // Find & remove port number
    domain = domain.split(':')[0];
    return domain;
  }
  handleLinkClick(event: Event, linkType: string, link: string, clickType: string): void {
    event.preventDefault(); // Prevent default behavior of the click event
    this.handleLink(link);
    this.analytic.onSubmitLinks(this.username, linkType, link, 'View');
    this.analytic.onSubmitLinks(this.username, linkType, link, clickType);
  }

  handleLink(link: string): void {
    if (this.isPhoneNumber(link)) {
      // Handle phone number
      if (confirm('Do you want download this Contact?')) {
          // Open phone app
          this.downloadVCard(link);
      } else {

      }
  }
   else if (this.isEmailAddress(link)) {
        // Handle email address
        window.location.href = 'mailto:' + link;
    } else if (this.isURL(link)) {

        // Handle URL by opening it in a new window
        window.open(link, '_blank');
    }
    // Add other cases here if necessary
  }

 isURL(link: string): boolean {
    // Define a regular expression pattern to match URLs
    const urlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\w]*[a-z0-9])*\.([a-z]{2,3})(:\d+)?(\/.*)?$/;
    return urlPattern.test(link);
 }


  isPhoneNumber(link: string): boolean {
    // Check if the link matches a phone number pattern (e.g., 10 digits)
    const phonePattern = /^\d{10}$/;
    return phonePattern.test(link);
  }

  isEmailAddress(link: string): boolean {
    // Check if the link matches an email address pattern
    const emailPattern = /^\S+@\S+\.\S+$/;
    return emailPattern.test(link);
  }


  GetSocilaLinks(uid:any){
    this.loading=true;
    this.api.read(`SocialLinks/SocilaLinks?userid=${uid}`).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe
    (
      {
        next:(response)=>{
          this.socialLink = response;
          this.loading    =false;
        },
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }

    )
   }
  ngOnInit(): void {

    this.username = this.route.snapshot.url[0].path
    this.Qr=this.Qr+this.username;
    // if (this.username != null) {
    //   this.analytic.onSubmitLinks(this.username, "Profile", this.profileLink + this.username,"View")
    // }
    this.GetAll(this.username);
  }


}
